:host {
  display: block;
  position: relative;

  .suggestions-container {
    position: absolute;
    display: block;
    visibility: hidden;
    padding: 8px 4px;
    width: 100%;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 1px 3px 0 rgb(81 81 81 / 75%);
    border-radius: 0 0 4px 4px;
    border: 1px solid var(--skin-color-primary, $ui-blue);
    top: 46px;
    box-sizing: border-box;
    z-index: 1;

    &.hasLabel {
      top: 81px;
    }

    &.active {
      visibility: visible;

      .suggestions {
        transition: max-height 0.5s;
        max-height: 519px;
      }
    }

    .suggestions {
      max-height: 0;
      overflow-y: auto;
    }

    &--label {
      margin-bottom: 12px;
      display: block;
    }
  }

  .ui-input {
    .input {
      &__field {
        padding-right: 80px;
      }
    }
  }

  ::slotted(ui-suggestion-group:not(:first-child)) {
    border-top: 1px solid var(--skin-color-secondary, $ui-grey);
  }
}
